var _line, _line2, _path, _path2, _path3, _path4, _line3, _line4, _line5, _line6, _line7, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line8, _line9, _line10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPillowBox = function SvgPillowBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "429.5mm",
    height: "153.0mm",
    viewBox: "0.0 -0.7499000000000002 429.5 153.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 30,
    y1: 25.750096116878122,
    y2: 125.75009611687813,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 230,
    y1: 24.750096116878122,
    y2: 126.75009611687813,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5,
    d: "M 429.5 126.7501 c 0 0 -40 -25 -99.75 -25 c -65 0 -99.75 25 -99.75 25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5,
    d: "M 230 127.2501 c 0 0 -35 -25 -100 -25 c -65 0 -100 25 -100 25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5,
    d: "M 230 24.2501 c 0 0 -35 25 -100 25 c -65 0 -100 -25 -100 -25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5,
    d: "M 429.5 25.2501 c 0 0 -35 25 -99.75 25 c -65 0 -99.75 -25 -99.75 -25"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 429.5,
    x2: 429.5,
    y1: 126.75009611687813,
    y2: 24.750096116878122,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 230,
    y1: 24.750096116878122,
    y2: 24.250096116878122,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 30,
    y1: 24.250096116878122,
    y2: 25.750096116878122,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 30,
    y1: 125.75009611687813,
    y2: 127.25009611687813,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 230,
    y1: 127.25009611687813,
    y2: 126.75009611687813,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 429.5 24.7501 C 384.5 -0.2499 339.5 0.0001 339.5 0.0001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 320 0.0001 A 9.75 9.75 0 0 0 339.5 0.0001"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 320 0.0001 C 320 0.0001 275 -0.2499 230 24.7501"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 230 24.2501 c 0 0 -35 -25 -100 -25 c -65 0 -100 25 -100 25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 30 127.2501 c 0 0 35 25 100 25 c 65 0 100 -25 100 -25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 230 126.7501 C 275 151.7501 320 151.5001 320 151.5001"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 339.5 151.5001 A 9.75 9.75 0 0 0 320 151.5001"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 339.5 151.5001 C 339.5 151.5001 384.5 151.7501 429.5 126.7501"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 40.750096116878126,
    y2: 110.75009611687813,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 0,
    y1: 125.75009611687813,
    y2: 110.75009611687813,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 0,
    y1: 25.750096116878122,
    y2: 40.750096116878126,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPillowBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pillow-box.614a170c.svg";
export { ForwardRef as ReactComponent };